import { BatchNavigationContext } from 'components/common-form/contexts/batch/BatchNavigationContext';
import { Context, useMemo } from 'react';

export const useCellState = (navigationContext: typeof BatchNavigationContext extends Context<infer T> ? T : never) => {
  const { isSelected, isEditing } = navigationContext;

  const isEditingCell = useMemo(() => {
    return isSelected && isEditing;
  }, [isSelected, isEditing]);

  return {
    isSelected,
    isEditing,
    isEditingCell,
  };
};
